<template>
    <div>
        <div class="search-deatail">
            <table class="search-deatail-table">
                <caption class="ir">상세검색</caption>
                    <colgroup>
                        <col width="20%">
                        <col width="70%">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th scope="row">분류</th>
                            <td class="background1">
                                <label class="label-hidden">
                                    <span scope="col" style="margin-right:30px; cursor: pointer;" @click="clickTblKorNm1('STBL-1014250')" :class="{'background2': isSelected1('STBL-1014250')}">문화</span>
                                    <span scope="col" style="margin-right:30px; cursor: pointer;" @click="clickTblKorNm1('STBL-1030638')" :class="{'background2': isSelected1('STBL-1030638')}">예술</span>
                                    <span scope="col" style="margin-right:30px; cursor: pointer;" @click="clickTblKorNm1('STBL-1014252')" :class="{'background2': isSelected1('STBL-1014252')}">콘텐츠</span>
                                    <span scope="col" style="margin-right:30px; cursor: pointer;" @click="clickTblKorNm1('STBL-1014253')" :class="{'background2': isSelected1('STBL-1014253')}">관광</span>
                                    <span scope="col" style="margin-right:30px; cursor: pointer;" @click="clickTblKorNm1('STBL-1014255')" :class="{'background2': isSelected1('STBL-1014255')}">체육</span>
                                    <span scope="col" style="margin-right:30px; cursor: pointer;" @click="clickTblKorNm1('STBL-1030639')" :class="{'background2': isSelected1('STBL-1030639')}">종합</span>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">조사</th>
                            <td class="background1">
                                <label class="label-hidden">
                                    <div class="statisticsDetailSearchListSub">
                                        <div class="label-container">
                                            <label v-for="(data, idx) in tblKorNm" :key="idx" :for="data" style="display: inline-block; cursor: pointer;">
                                                <span class="checkbox-text" :class="{ 'background2': isSelected2(data.tblMgmNo) }"  @click="clickTblKorNm2(data.tblMgmNo)">{{ data.tblKorNm }}</span>
                                            </label>
                                        </div>
                                    </div>
                                </label>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><label for="tblKorNmString" >통계표</label></th>
                            <td>
                                <input type="text" v-model="tblKorNmString" id="tblKorNmString" v-on:keyup.enter="searchDetail(true)" placeholder="통계명 중 포함된 단어를 검색, 여러 단어일경우에는 ','로 붙여서 입력">
                            </td>
                        </tr>
                        <tr>
                            <th scope="row"><label for="itmKorNmString">항목명</label></th>
                            <td>
                                <input type="text" v-model="itmKorNmString" id="itmKorNmString" v-on:keyup.enter="searchDetail(true)" placeholder="항목이 포함된 단어를 검색, 여러 단어일 경우에는 ','로 붙여서 입력">
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">입력연도</th>
                            <td>
                                <label class="label-hidden">
                                    <input type="text" class="select-box-btn" id="selectBoxBtn" v-model="yearString" @click.prevent="selectYearString($event)" placeholder="클릭해서 연도를 선택해주세요.">
                                </label>
                                <div class="select-box-yy" id="selectBoxYY">
                                    <!-- <div class="select-box-yy" id="selectBoxYY" v-click-outside> -->
                                    <ul id="selectBoxUL">
                                        <li v-for="(data, idx) in yearList" v-bind:key="idx">
                                            <input type="checkbox" name="chkCreTme" :id='data' :value='data' v-model="checkYearList" @change="selectYear($event)">
                                            <label :for='data' >{{data}}</label>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
            </table>
        </div>
        <div class="btn-layout right">
            <button type="button" class="gray btn small" @click="searchDetail(true)">검색</button>
        </div>
        <div class="search-result">
            <span class="total">검색결과 <span class="num">{{ numberFormat(totalDetailCnt) }}</span>건</span>
            <ul class="search-result-list">
                <li v-for="(data, idx) in staticsDetailData" v-bind:key="idx">
                    <a href="#/" @click.prevent="$parent.staticDetail(data.levelId2, data.tblMgmNo, data.upPath, data.tblKorNm, data.cmmtDesc)">
                        <div class="title-address">
                            <strong class="result-title">{{ data.tblKorNm }} </strong>
                            <div class="address">
                                <span>{{ formatPath(data.upPath) }}</span>
                            </div>
                        </div>
                        <div class="result-date" v-if="data.termList[0] != null">
                            <p>{{ data.termList[0].startMonth }}<i>&nbsp;~&nbsp;</i>{{ data.termList[0].endMonth }}</p>
                        </div>
                    </a>
                </li>
            </ul>
            <div class="btn-layout center" v-if="isDetailSearchData">
                <button type="button" class="line btn" @click="statisticsDetailSearchList">더보기</button>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '@/api/Statistics.js'
import $ from 'jquery'

export default {
	name: 'SearchStatDetail',

	data () {
		return {
			staticsDetailData: [],
			totalDetailCnt: 0,
			detailCount: 10,
			detailPageIndex: 0,
			detailStartPage: 0,
			detailEndPage: 0,
			isDetailSearchData: false,
			tblKorNmString: '',
			itmKorNmString: '',
			yearString: '',
			yearList: [],
			checkYearList: [],
			tblKorNm: '',
			upTblMgmNo: '',
			tblMgmNo: '',
			tblKorNmList1: [],
			tblKorNmList2: [],
			KorNmString1: '',
			KorNmString2: ''

		}
	},
	created () {
		this.searchDetailSub()
	},
	//	분류 조건 추가 상세조회
	methods: {
		async searchDetailSub () { // selectStatisticsDetailSearchListSub
			const paramData = {
				upTblMgmNo: this.upTblMgmNo,
				tblMgmNo: this.tblMgmNo,
				tblKorNm: this.tblKorNm
			}
			// var list=[];
			this.tblKorNm = []
			const datalist = await api.statisticsDetailSearchListSub(paramData)
			datalist.data.forEach(data => this.tblKorNm.push(data))

			// console.log(datalist.data)
		},
		// 분류 조건 텍스트 클릭할 경우 색 변경
		isSelected1 (tblMgmNo) {
			// 해당 값이 선택되었는지 여부를 확인하여 true 또는 false를 반환
			return this.tblKorNmList1.includes(tblMgmNo)
		},
		// 조사 조건 텍스트 클릭할 경우 색 변경
		isSelected2 (tblMgmNo) {
			return this.tblKorNmList2.includes(tblMgmNo)
		},

		// 상세 검색 중 분류 검색 필터
		clickTblKorNm1 (tblMgmNo) {
			const index = this.tblKorNmList1.indexOf(tblMgmNo)
			if (index > -1) { // 이미 있을떄
				this.tblKorNmList1.splice(index, 1)
			} else {
				this.tblKorNmList1.push(tblMgmNo)
			}
			// console.log(this.tblKorNmList1) //배열 형태 출력

			let tblKorNmString = '' // 빈문자열 초기화
			if (this.tblKorNmList1.length > 0) { // List길이 확인 후 참인 경우
				for (let i = 0; i < this.tblKorNmList1.length; i++) { // for문 사용해 배열의 각 요소 반복
					// console.log(this.tblKorNmList1[i])
					if (i == 0) tblKorNmString += this.tblKorNmList1[i] // i가 0인게 참이면 tblKorNmString에 값 추가
					else tblKorNmString += ',' + this.tblKorNmList1[i]// i가 0인게 거짓이면 쉼표 다음에 추가
				}
			} else {
				tblKorNmString = '' // 배열이 없을 경우 빈 문자열로 표시
			}

			this.KorNmString1 = tblKorNmString // KorNmString 속성은 tblKorNmString로 값 업데이트
			// console.log( this.KorNmString1) //스트링 형태 출력
		},

		// 상세 검색 중 조건 검색 필터
		clickTblKorNm2 (tblMgmNo) {
			const index = this.tblKorNmList2.indexOf(tblMgmNo)
			if (index > -1) { // 이미 있음
				this.tblKorNmList2.splice(index, 1)
			} else {
				this.tblKorNmList2.push(tblMgmNo)
			}
			// console.log(this.tblKorNmList2)

			// 빈문자열 초기화. 위의 list에 담긴값을  string값으로 만들어 주기
			let tblKorNmString = ''

			if (this.tblKorNmList2.length > 0) {
				for (let i = 0; i < this.tblKorNmList2.length; i++) {
					// console.log(this.checkYearList[i])
					if (i == 0) tblKorNmString += this.tblKorNmList2[i]
					else tblKorNmString += ',' + this.tblKorNmList2[i]
				}
			} else {
				tblKorNmString = ''
			}

			this.KorNmString2 = tblKorNmString
			// console.log( this.KorNmString2)
		},

		// 상세검색 - 검색 버튼 클릭 시
		searchDetail (initGubun) {
			this.detailPageIndex = 0
			this.detailStartPage = 0
			this.detailEndPage = 0
			this.staticsDetailData = []

			if (initGubun) this.statisticsDetailSearchList()
		},

		// 상세검색 - 입력연도 클릭 시
		selectYearString (event) {
			var list = []
			var year = new Date().getFullYear() - 1
			for (let i = year; i >= 2000; i--) list.push(i)
			this.yearList = list

			$('.select-box-btn').parent().next().toggleClass('on')
		},

		// 상세검색 - 입력연도 체크박스 클릭 시
		selectYear (event) {
			let tmpYearString = ''
			if (this.checkYearList.length > 0) {
				for (let i = 0; i < this.checkYearList.length; i++) {
					if (i == 0) tmpYearString += this.checkYearList[i]
					else tmpYearString += ',' + this.checkYearList[i]
				}
			} else {
				tmpYearString = ''
			}

			this.yearString = tmpYearString
		},

		// 상세검색
		async statisticsDetailSearchList () {
			this.detailPageIndex = this.detailPageIndex + 1
			this.detailStartPage = ((this.detailPageIndex - 1) * this.detailCount) + 1
			this.detailEndPage = this.detailPageIndex * this.detailCount

			const paramData = {
				tblKorNmString: this.tblKorNmString,
				itmKorNmString: this.itmKorNmString,
				yearString: this.yearString,
				startPage: this.detailStartPage,
				endPage: this.detailEndPage,
				KorNmString2: this.KorNmString2, // 추가
				KorNmString1: this.KorNmString1
			}

			const datalist = await api.statisticsDetailSearchList(paramData)
			this.totalDetailCnt = datalist.cnt
			// console.log(this.totalDetailCnt)

			if (datalist.data.length > 0) {
				datalist.data.forEach(data => this.staticsDetailData.push(data))
			}

			this.isDetailSearchData = true

			if (datalist.data.length < this.detailCount) {
				this.isDetailSearchData = false
			}
		},

    // 통계표 목록 Path 변경
    formatPath (path) {
      return path ? path.replace(/>>/g, ' > ') : ''
    },

    numberFormat(value) {
      if(!value) return '0';
      const numberValue = Number(value);
      return numberValue.toLocaleString();
    },
	}
}
</script>

<style scoped>
.label-container label {
  margin-right: 30px;

}
.background1{
    color: #666;
    letter-spacing: normal;
    font-weight: normal;
    line-height: 30px;
}

.background2{
    color: #4a45af;
    letter-spacing: normal;
    font-weight: bold;
    line-height: 30px;
}
</style>
